import React, { useState, useEffect } from 'react';
import { getRequest, postRequest } from 'apis/ApiInstence';
import { toast } from 'react-toastify';

const QrCodeList = () => {
    const [data, setData] = useState(null)

    const getData = async () => {
        const res = await getRequest(`qrcode`);
        setData(res?.data?.name)
    }
    useEffect(() => {
        getData()
    }, [])


    const handleEditClick = async () => {
        const res = await postRequest(`qrcode`, {
            name: data
        });

        if (res?.status) {
            toast('QR updated successfully!')
        } else {
            toast('Failed to update QR!')
        }
    };


    return (
        <div className="container-fluid mt-5">
            <div className='mainheadig mx-4'>
                <h4 className="text-white font-weight-bold">QR Code </h4>
            </div>
            <div className='form-style'>
                <label htmlFor='qrcodeId' className='mx-4 mt-4 font-weight-bold' >QR code </label>
                <input id='qrcodeId' className='form-control' defaultValue={data} onChange={(e) => setData(e.target.value)} />
                <button className='btn btn-lg addbtn mt-4 mx-4' onClick={handleEditClick} >Update QR</button>
            </div>
        </div>
    );
};

export default QrCodeList;
